import NetworkParticipationBox from './NetworkParticipationBox';
import StyledNetworkParticipationBox from './StyledNetworkParticipationBox';

export type { NetworkParticipationBoxProps } from './NetworkParticipationBox';

export { StyledNetworkParticipationBox };

export default NetworkParticipationBox;
